
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSchema]/landing",
      function () {
        return require("private-next-pages/[teamSchema]/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSchema]/landing"])
      });
    }
  